import resolveEntityBreadcrumbLabel from '../../../helpers/resolveEntityBreadcrumbLabel';
import type { ResolvePlaybookBreadcrumbLabelParams } from '../types';

const resolvePlaybookBreadcrumbLabel = ({
    playbookId,
    playbookName,
    isLoadingPlaybook,
}: ResolvePlaybookBreadcrumbLabelParams): string =>
    resolveEntityBreadcrumbLabel({
        entityId: playbookId,
        entityName: playbookName,
        isLoading: isLoadingPlaybook,
        entityKindLabel: 'Playbook',
    });

export default resolvePlaybookBreadcrumbLabel;
